import { html, css } from 'lit';
import { Styles } from '../types/types';
import OlComponent from './OlComponent';

export default class LineHeightComponent extends OlComponent {
    onClick: (value: Styles["line-height"]) => void;

    constructor(onClick: (value: Styles["line-height"]) => void) {
        super();
        this.onClick = onClick;
    }

    override styles = css`
    .lh-buttons button {
        border-radius: 20px;
        border: none;
    }
    .lh-buttons button:hover {
        box-shadow: 2px 2px 3px 2px rgba(0,0,0,.1);
        opacity: 1;
    }`

    override render() {
        return (
            html`
            <style>${this.styles}</style>
            <div class="lh-buttons container">
                <button @click=${() => this.onClick("1")} part="button">1x</button>
                <button @click=${() => this.onClick("1.5")} part="button">1.5x</button>
                <button @click=${() => this.onClick("2")} part="button">2x</button>
                <button @click=${() => this.onClick("3.5")} part="button">3x</button>
            </div>`
        )
    }
}